import * as React from 'react';
import {useSelector} from 'react-redux';

import {Assignables} from 'nutshell-core/assignables';

import {AssigneeSelect} from 'shells/assignee-select/assignee-select';
import {SegmentedControl} from 'shells/card/segmented-control';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import type {SaveState} from 'shells/saved-setting-toast/use-manage-save-state';
import {Body} from 'shells/typography/body';
import {LabelWithContent} from 'shells/typography/label-with-content';

import type {ChatAssignmentStrategyEnum} from 'nutshell-graphql-types';

import {ASSIGNMENT_OPTIONS, SAVE_STATE_KEYS} from '../../consts';
import type {SaveStateKey} from '../../consts';
import {getExplanationForStrategy} from '../../helpers';

type Props = {
    selectedValue: ChatAssignmentStrategyEnum;
    setSelectedValue: (arg1: ChatAssignmentStrategyEnum) => void;
    assignedUserId: string | null | undefined;
    setAssignedUserId: (arg1?: string | null | undefined) => void;
    savingToastKey?: SaveStateKey | null | undefined;
    toastState?: SaveState;
};

export const AssignmentOptionsContentNew = (props: Props) => {
    const assignables = useSelector(Assignables.getAgents);

    return (
        <LabelWithContent
            spacing={16}
            label={<Body>When a human agent is available, assign threads via:</Body>}
            state={
                props.savingToastKey === SAVE_STATE_KEYS.ASSIGNMENT ? props.toastState : 'initial'
            }
            content={
                <StackLegacy spacing={12}>
                    <SegmentedControl
                        buttonOptions={ASSIGNMENT_OPTIONS}
                        selectedValue={props.selectedValue}
                        setSelectedValue={props.setSelectedValue}
                        isAnimated={true}
                    />
                    <Body color='light' size='small'>
                        {getExplanationForStrategy(props.selectedValue)}
                    </Body>
                    {props.selectedValue === 'SPECIFIC_USER' && (
                        <div className='mb-8'>
                            <AssigneeSelect
                                value={props.assignedUserId}
                                // @ts-expect-error
                                options={assignables}
                                isClearable={false}
                                onChange={props.setAssignedUserId}
                                minHeight={34}
                            />
                        </div>
                    )}
                </StackLegacy>
            }
        />
    );
};
